<div
  padding-tb-small
  layout
  layout-horizontal
  layout-full-width
  layout-align-items-center
  layout-space-between
  cursor-pointer
>
  <div class="left-content" layout-vertical padding-right-small>
    <div layout-horizontal>
      <rt-checkbox
        [checked]="task.completed"
        [disabled]="loading"
        class="selector"
        (valueChange)="toggle()"
      />
      <div class="title" [innerHTML]="task.title | taskTitleWrapUrls"></div>
    </div>
    @if (task.description || task.dueDate) {
      <div
        layout-horizontal
        layout-align-items-center
        margin-top-small-xx
        gap-small
        class="description-wrap"
      >
        @if (task.dueDate) {
          <span
            class="due-date"
            [ngClass]="dateClass!"
            [rtTooltip]="dueDate | amDateFormat: dueDateTooltipFormat"
            [rtTooltipPosition]="'above'"
            layout-horizontal
            layout-align-items-center
            gap-small-xx
          >
            <rt-icon name="access-time" size="small-x" />
            <span ngPreserveWhitespaces class="time-date-wrap">
              <span class="humanized-date-wrap">{{ humanizedDate }}</span
              >,
              <span class="time-wrap">{{ dueDate | amDateFormat: 'LT' }}</span>
            </span>
          </span>
        }

        @if (task.description) {
          <span layout-horizontal layout-align-items-center gap-small-xx>
            <rt-icon
              name="message"
              size="small-x"
              [rtTooltip]="'app.tasks.note_tooltip' | translate"
              [rtTooltipPosition]="'above'"
            />
            {{ 'app.tasks.note' | translate }}
          </span>
        }
      </div>
    }
  </div>
  <div class="right-content" layout layout-horizontal layout-align-items-center>
    @if (task.admins) {
      <rt-admins-avatars [admins]="$any(task.admins)" [stacked]="true" [limit]="3" variant="ltr">
      </rt-admins-avatars>
    }
    @if (task.triggered) {
      <rt-icon
        [rtTooltip]="'app.automated_actions.automated_actions' | translate"
        name="automated-actions"
        size="small"
        [attr.margin-left-auto]="!task.admins ? '' : null"
        margin-left-small-x
      >
      </rt-icon>
    }
    <rt-date
      [tiny]="true"
      [time]="task.createdAt"
      tooltipPosition="left"
      variant="small no-wrap"
      margin-left-small-x
    >
    </rt-date>
  </div>
</div>
